export const THEME_PREFERENCES = ["light", "dark", "system"] as const;

export type ThemePreference = (typeof THEME_PREFERENCES)[number];

export type ThemeMode = Exclude<ThemePreference, "system">;

export const DEFAULT_THEME_PREFERENCE: ThemePreference = "system";

export const isThemePreference = (value: unknown): value is ThemePreference =>
  typeof value === "string" && (THEME_PREFERENCES as readonly string[]).includes(value);

export const toThemePreferenceLabel = (preference: ThemePreference): string => {
  switch (preference) {
    case "light":
      return "Light";
    case "dark":
      return "Dark";
    case "system":
    default:
      return "System";
  }
};
